'use client';
import { Box, Button, Flex, Link, Text, Image } from '@skin-seoul/design-system';
import { overlay } from 'overlay-kit';

import { SkinSocietyBenefitsModal } from '../../SkinSocietyBenefitsModal';

export const LoyaltyPointsSignUpBannerMobile = () => {
  const handleViewBenefits = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();

    overlay.open(({ isOpen, close }) => (
      <SkinSocietyBenefitsModal isOpen={isOpen} onClose={close} showBottomNav={false} showSigninComment={true} />
    ));
  };

  return (
    <Box position="relative" width="100%" borderRadius="8px" overflow="hidden">
      {/* Base gradient background */}
      <Box position="absolute" inset="0" bgGradient="to-r" gradientFrom="#311275" gradientTo="#754DCC" />

      {/* Decorative gift icon */}

      {/* Content layer */}
      <Flex position="relative" height="100%" alignItems="center" justifyContent="space-between" p={3} zIndex={1}>
        {/* Left Side - Text Content */}
        <Box position="absolute" left="0px" color="primary.100" zIndex={0}>
          <Image
            src="https://dev-media.skin-seoul.com/loyalty/mobile-sign-up-gift.png"
            alt="Gift Icon"
            width="44px"
            height="72px"
          />
        </Box>
        <Flex direction="column" gap={1} pl="30px">
          <Box>
            <Text as="span" color="primary.100" textStyle="heading.h6.mobile" fontWeight="bold" display="block">
              Claim All Benefits,
            </Text>
            <Text as="span" color="primary.100" textStyle="heading.h6.mobile" fontWeight="bold" display="block">
              Right here
            </Text>
          </Box>
          <Text color="primary.200" textStyle="label.small" fontWeight="medium">
            Sign up & Join Skin Society Now!
          </Text>
        </Flex>

        {/* Right Side - Buttons */}
        <Flex direction="column" gap={3.5} alignItems="flex-start">
          <Button
            asChild
            size="sm"
            variant="primary"
            bg="white"
            color="black"
            _hover={{ bg: 'neutral.50' }}
            px={4}
            height="36px"
          >
            <Link unstyled href="/my-account/">
              Sign In
            </Link>
          </Button>
          <Box
            as="button"
            onClick={handleViewBenefits}
            color="white"
            textStyle="label.small"
            fontWeight="medium"
            textDecoration="underline"
            cursor="pointer"
            bg="transparent"
            border="none"
            _hover={{ color: 'primary.100' }}
          >
            View Benefits
          </Box>
        </Flex>
      </Flex>
    </Box>
  );
};
